import moment from 'moment'
const digitsRE = /(\d{3})(?=\d)/g

const prettifyDate = (value) => moment(value).format('DD.MM.YYYY')
const prettifyBoolean = (value) => (value ? 'Yes' : 'No')
const prettifyList = (value) => (value || []).join(', ')
const prettifyNumber = (value, decimals) => {
  value = parseFloat(value)
  if (!isFinite(value) || (!value && value !== 0)) return ''
  decimals = decimals != null ? decimals : 2
  const stringified = Math.abs(value).toFixed(decimals)
  const _int = decimals
    ? stringified.slice(0, -1 - decimals)
    : stringified
  const i = _int.length % 3
  const head = i > 0
    ? (_int.slice(0, i) + (_int.length > 3 ? ',' : ''))
    : ''
  const _float = decimals
    ? stringified.slice(-1 - decimals)
    : ''
  const sign = value < 0 ? '-' : ''
  return sign + head +
    _int.slice(i).replace(digitsRE, '$1,') +
    _float
}
const prettifyCurrency = (value, currency, decimals) => {
  value = parseFloat(value)
  if (!isFinite(value) || (!value && value !== 0)) return ''
  currency = currency != null ? currency : 'Ft '
  decimals = decimals != null ? decimals : 2
  const stringified = Math.abs(value).toFixed(decimals)
  const _int = decimals
    ? stringified.slice(0, -1 - decimals)
    : stringified
  const i = _int.length % 3
  const head = i > 0
    ? (_int.slice(0, i) + (_int.length > 3 ? ',' : ''))
    : ''
  const _float = decimals
    ? stringified.slice(-1 - decimals)
    : ''
  const sign = value < 0 ? '-' : ''
  return currency + '   ' + sign + head +
    _int.slice(i).replace(digitsRE, '$1,') +
    _float
}

export function useFilters () {
  return {
    prettifyDate,
    prettifyBoolean,
    prettifyList,
    prettifyNumber,
    prettifyCurrency
  }
}
